import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Dialog from '../dialog.jsx';
import DestinationSections from '../destination_sections.jsx';
import classnames from 'classnames';
import { capitalize } from 'utils';

function ValidationError({ error, id }) {
    if (error != null) {
        return (
            <div className="validation-error" id={id}>
                {error}
            </div>
        );
    }
    return <span />;
}
ValidationError.propTypes = {
    error: PropTypes.string,
    id: PropTypes.string,
};

export default class LinkDisplay extends PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        onSave: PropTypes.func,
        sections: PropTypes.any,
        terms: PropTypes.any,
        validationErrors: PropTypes.shape({
            value: PropTypes.any,
            requestChange: PropTypes.func,
        }),
        selectedSections: PropTypes.array,
        title: PropTypes.string,
        url: PropTypes.string,
        embed: PropTypes.string,
        description: PropTypes.string,
        setContent: PropTypes.func,
    };

    constructor({ title, url, embed, description, setContent }) {
        super();
        Object.keys({
            title,
            url,
            embed,
            description,
        }).forEach(key => {
            this[`set${capitalize(key)}`] = ({ currentTarget: { value } }) =>
                setContent({ [key]: value });
        });
    }

    setSelectedSections = selectedSections => {
        this.props.setContent({ selectedSections });
    };

    render() {
        const {
            sections,
            terms,
            validationErrors,
            selectedSections,
            title,
            url,
            embed,
            description,
        } = this.props;

        const buttons = [];
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Add Link',
            onClick: this.props.onSave,
            primary: true,
        });

        return (
            <Dialog
                buttons={buttons}
                closeButton
                onClose={this.props.onClose}
                title="Add External Link"
            >
                <div id="formLegend">
                    <p>All fields are required unless otherwise noted.</p>
                </div>
                <fieldset>
                    <legend className="aural">Link Title</legend>
                    <label
                        className={classnames({
                            'validation-error': validationErrors.title,
                        })}
                        htmlFor="_engage64"
                    >
                        Title
                    </label>
                    <input
                        value={title}
                        onChange={this.setTitle}
                        required="required"
                        type="text"
                        id="_engage64"
                        aria-required
                    />
                    <ValidationError error={validationErrors.title} />
                </fieldset>
                <fieldset>
                    <legend className="aural">Link URL</legend>
                    <label
                        className={classnames({
                            'validation-error': validationErrors.url,
                        })}
                        htmlFor="_engage65"
                    >
                        URL
                    </label>
                    <input
                        value={url}
                        onChange={this.setUrl}
                        required="required"
                        type="text"
                        id="_engage65"
                        aria-required
                    />
                    <ValidationError error={validationErrors.url} />
                </fieldset>
                <fieldset>
                    <legend className="aural">
                        Embed HTML Code For Video or Other Content
                    </legend>
                    <label htmlFor="_engage66">
                        Embed Code
                        <span className="secondary">(Optional)</span>
                    </label>
                    <textarea
                        value={embed}
                        onChange={this.setEmbed}
                        name="embed"
                        aria-describedby="aria-embed-instructions"
                        id="_engage66"
                    />
                    <aside id="aria-embed-instructions">
                        <p className="secondary">
                            URLs must begin with 'https:'. URLs that begin with
                            'http:' or have no protocol specified will be
                            automatically updated.
                            <a
                                href="https://resources.unizin.org/display/EKB/About+Embed+Code+in+Engage"
                                title="View our help on this topic"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Learn more
                            </a>
                        </p>
                    </aside>
                </fieldset>
                <fieldset>
                    <legend className="aural">Link Description</legend>
                    <label htmlFor="linkDescription">
                        Description
                        <span className="secondary">(Optional)</span>
                    </label>
                    <textarea
                        value={description}
                        onChange={this.setDescription}
                        name="description"
                        id="linkDescription"
                    />
                </fieldset>

                <ValidationError
                    error={validationErrors.sections}
                    id="error-sections"
                />
                <DestinationSections
                    sections={sections}
                    terms={terms}
                    selectedSections={selectedSections}
                    onChange={this.setSelectedSections}
                    error={validationErrors.sections}
                />
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/link_dialog/display.jsx